<label
    class="switch"
    [class.disabled]="disabled"
    [ngClass]="size"
    [style.--switch-color]="color"
>
    <input
        type="checkbox"
        [checked]="checked"
        [disabled]="disabled"
        (change)="toggle($event)"
    />
    <span class="slider"></span>
</label>
